{
  "it": {
    "task": {
      "actions": {
        "create": "Attività",
        "update": "Modifica attività"
      },
      "attributes": {
        "assignments_count": "Assegnazioni",
        "category": "Categoria",
        "created_at": "Creato",
        "description": "Descrizione",
        "title": "Titolo",
        "units": "Unità"
      },
      "categories": {
        "confirmation": "Conferma",
        "upload": "Caricamento"
      },
      "labels": {
        "no_tasks": "Ancora nessuna attività per questo progetto.",
        "required": "Questo campo è obbligatorio",
        "units_required": "Selezioni almeno un’unità"
      },
      "toasts": {
        "create": "Attività creata",
        "delete": "Attività eliminata",
        "update": "Attività aggiornata"
      }
    }
  }
}
